export const queryListingConstants = {
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
    GETALLQUERYLISTING_REQUEST: 'GETALLQUERYLISTING_REQUEST',
    GETALLQUERYLISTING_REQUEST_END: 'GETALLQUERYLISTING_REQUEST_END',

    GETALLQUERYLISTING_SUCCESS: 'GETALLQUERYLISTING_SUCCESS',
    GETALLQUERYLISTING_FAILURE: 'GETALLQUERYLISTING_FAILURE'

};